module.exports = __webpack_public_path__ + "img/编组 5@2x1.05ee8b8f.png";